module.exports = __webpack_public_path__ + "img/knu2_gallery6.5be68f95.jpg";